import { Card, CardContent, Link, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { WalletModel } from 'src/common/api'
import { QCADIcon } from 'src/common/assets'
import { formatNumber, trimId } from 'src/common/helpers'
import { EXPLORER, WALLET_ICON, ChainName } from 'src/common/static'
import * as S from './styles'

interface WalletCardProps {
  wallet: WalletModel
}

const WalletCard: React.FC<WalletCardProps> = ({ wallet }: WalletCardProps) => {
  const { id, name, address, balance, chain } = wallet
  const Icon = WALLET_ICON[chain]

  return (
    <Box mt="24px" key={id}>
      <Card elevation={3}>
        <CardContent sx={{ p: '20px' }}>
          <Box display="flex" alignItems="center" mb={3}>
            <Icon fontSize="large" />
            <Typography variant="h6" ml={1.5} width="215px" noWrap>
              {name}
            </Typography>
          </Box>
          <Stack spacing={2} mb={2.5}>
            <Stack direction="row">
              <QCADIcon />
              <Typography flexGrow={1} ml={2}>
                QCAD
              </Typography>
              <Typography>{formatNumber(balance?.qcad ?? balance?.qcad_xlm ?? 0)}</Typography>
            </Stack>
          </Stack>
          <Stack direction="row" alignItems="center">
            <S.CircleIcon connected={true} />
            <Typography ml={1} flexGrow={1} variant="body2">
              Connected
            </Typography>
            <Link
              component="a"
              target="_blank"
              rel="noopener"
              href={
                chain != ChainName.STELLAR
                  ? `${EXPLORER[chain]}/address/${address}`
                  : `${EXPLORER[chain]}/account/${address}`
              }
              color="inherit"
              variant="body2"
            >
              {trimId(address)}
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}

export default WalletCard
